import { createReducer, on } from '@ngrx/store';
import * as UsersActions from './users.actions';
import { initialUsersState } from './users.state';

export const usersReducer = createReducer(
  initialUsersState,

  on(UsersActions.loadUsers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UsersActions.loadUsersSuccess, (state, { users, pagination }) => ({
    ...state,
    users,
    pagination,
    loading: false,
    error: null,
  })),

  on(UsersActions.loadUsersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UsersActions.createUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UsersActions.createUserSuccess, (state, { user }) => ({
    ...state,
    users: [ ...state.users, user ],
    loading: false,
    error: null,
  })),

  on(UsersActions.createUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UsersActions.updateUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UsersActions.updateUserSuccess, (state, { user }) => ({
    ...state,
    users: state.users.map(u => u.id === user.id ? user : u),
    loading: false,
    error: null,
    selectedUser: state.selectedUser?.id === user.id ? user : state.selectedUser,
  })),

  on(UsersActions.updateUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UsersActions.deleteUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UsersActions.deleteUserSuccess, (state, { id }) => ({
    ...state,
    users: state.users.filter(u => u.id !== id),
    loading: false,
    error: null,
    selectedUser: state.selectedUser?.id === id ? null : state.selectedUser,
  })),

  on(UsersActions.deleteUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UsersActions.selectUser, (state, { user }) => ({
    ...state,
    selectedUser: user,
  })),
);
